@if (isReady()) {
    <app-table
        [translatePrefix]="prefix"
        [columns]="columns"
        [additionalFilter]="additionalFilter()"
        [gridData]="store.data.getEPrescriptions()"
        [refreshCallback]="store.api.getEPrescriptions"
        [refreshCallbackFragment]="tableFragment"
        (createCallback)="create($event)"
        [defaultSorters]="[{ column: 'issuedAt', direction: 'DESC' }]"
        [hideCheckboxes]="true"
        [showCreate]="canCreate()"
    >
        <ng-template pTemplate="print" let-item="item">
            <app-button size="large" icon="pi-print" severity="help" [text]="true"
                (clickEvent)="print(item)"></app-button>
        </ng-template>

        <ng-template pTemplate="medications" let-item="item" let-data="data">
            <div class="flex flex-column">
                @if (item.magistraliter) {
                    <span>{{ item.magistraliter.amount }}× {{ item.magistraliter.name }}</span>
                } @else if (data[0]?.code) {
                    <app-medication-info [medicationCode]="data[0]?.code || ''"></app-medication-info>
                }
                @if (data[1]?.code) {
                    <app-medication-info [medicationCode]="data[1]?.code || ''"></app-medication-info>
                }
            </div>
        </ng-template>

        <ng-template pTemplate="work" let-data="data">
            @if (data) {
                <app-link-button (click)="goToWork(data)" [label]="data?.dateFrom | shortDate"></app-link-button>
            }
        </ng-template>

    </app-table>
}
